<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('bank_accounts.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openBankAccountForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetBankAccounts(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="$t('lang.active_only')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="bank_accounts" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openBankAccountForm(props.item)">
                                <td>{{ props.item.account_id }}</td>
                                <td>{{ props.item.account_name }}</td>
                                <td>{{ props.item.bank_name }}</td>
                                <td>{{ props.item.branch_name }}</td>
                                <td>{{ props.item.balance }}</td>
                                <td>{{ props.item.is_active }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="bank_accounts"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="bank_account_dialog">
                <v-card>
                    <v-form ref="form_bank_account">
                        <v-card-title>
                            <span class="headline">{{ bank_account.account_id != null ? $t("lang.edit_bank_account") : $t("lang.add_bank_account") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeBankAccountDialog"
                                :dialog-status="bank_account_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bank_account.account_number"
                                            :label="$t('lang.account_number')"
                                            :counter="showCounter(bank_account.account_number, 'bank_accounts.account_number')"
                                            :rules="ifValid('bank_accounts.account_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bank_account.account_name"
                                            :label="`${$t('lang.account_name')} *`"
                                            :counter="showCounter(bank_account.account_name, 'bank_accounts.account_name')"
                                            :rules="ifValid('bank_accounts.account_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bank_account.bank_name"
                                            :label="`${$t('lang.bank_name')} *`"
                                            :counter="showCounter(bank_account.bank_name, 'bank_accounts.bank_name')"
                                            :rules="ifValid('bank_accounts.bank_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bank_account.branch_name"
                                            :label="$t('lang.branch_name')"
                                            :counter="showCounter(bank_account.branch_name, 'bank_accounts.branch_name')"
                                            :rules="ifValid('bank_accounts.branch_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bank_account.account_type"
                                            :label="$t('lang.account_type')"
                                            :counter="showCounter(bank_account.account_type, 'bank_accounts.account_type')"
                                            :rules="ifValid('bank_accounts.account_type')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bank_account.routing_number"
                                            :label="$t('lang.routing_number')"
                                            :counter="showCounter(bank_account.routing_number, 'bank_accounts.routing_number')"
                                            :rules="ifValid('bank_accounts.routing_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="bank_account.currency_id"
                                            :label="$t('lang.currency_id')"
                                            :items="currencies"
                                            item-value="currency_id"
                                            item-text="name"
                                            :rules="ifValid('bank_accounts.currency_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="bank_account.balance"
                                            :label="$t('lang.balance')"
                                            :counter="showCounter(bank_account.balance, 'bank_accounts.balance')"
                                            :rules="ifValid('bank_accounts.balance')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
                                            v-model="bank_account.is_active"
                                            :label="$t('lang.is_active')"
                                            :items="['1', '0']"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('bank_accounts.is_active')"
                                        ></bc-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="bank_account.account_id" color="error" @mouseup.left="$refs.delete_bank_accounts.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeBankAccountDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveBankAccounts">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_bank_accounts"
                :heading="$t('lang.delete_bank_account')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteBankAccounts(bank_account.account_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openBankAccountForm" },
                { title: this.$t("lang.refresh"), action: "dbGetBankAccounts", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.account_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.account_name"), sortable: false, width: "10%" },
                { text: this.$t("lang.bank_name"), sortable: false, width: "10%" },
                { text: this.$t("lang.branch_name"), sortable: false, width: "10%" },
                { text: this.$t("lang.balance"), sortable: false, width: "10%" },
                { text: this.$t("lang.is_active"), sortable: false, width: "10%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            bank_account: {},
            filter: {
                search: "",
                status: "1",
            },
            bank_account_dialog: false,
            dbGetBankAccounts: _.debounce(this.getBankAccounts, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchBankAccounts", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.bank_accounts) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchBankAccounts({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.bank_accounts) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.bank_accounts.bank_accounts_filter,
            page: (state) => state.bank_accounts.page,
            rules_bank_accounts: (state) => state.bank_accounts.rules_bank_accounts,
            bank_account_status_options: (state) => state.settings.bank_account_status_options,
            bank_accounts: (state) => state.bank_accounts.bank_accounts,
            currencies: (state) => state.currencies.currencies,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchBankAccounts", "saveBankAccount", "deleteBankAccount", "fetchCurrencies"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openBankAccountForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_bank_account) item ? this.$refs.form_bank_account.resetValidation() : this.$refs.form_bank_account.reset();

                    this.$nextTick(() => {
                        this.bank_account = item != null ? this.assignObj2(item, this.rules_bank_accounts) : {};
                        this.bank_account_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "bank_account", params: { id: item.account_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_bank_account) item ? this.$refs.form_bank_account.resetValidation() : this.$refs.form_bank_account.reset();
                    this.bank_account_dialog = true;
                } else {
                    this.$router.push({ name: "bank_account" });
                }
            }
        },
        saveBankAccounts() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_bank_account")) {
                    let body = this.prepForm(this.bank_account, this.rules_bank_accounts);

                    this.saveBankAccount({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getBankAccounts();
                                this.closeBankAccountDialog();
                            } else {
                                this.$router.push({ name: "bank_account", params: { id: data.account_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteBankAccounts(id = null) {
            this.deleteBankAccount({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getBankAccounts();
                    this.closeBankAccountDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeBankAccountDialog() {
            this.bank_account_dialog = false;
            this.$refs.delete_bank_accounts.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getBankAccounts(pg_refresh = false) {
            this.startLoader();

            this.fetchBankAccounts({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.bank_account_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            if (this.currencies.length == 0 || force == true) await this.fetchCurrencies({ body: { options: 1 } });
        },
    },
    mounted() {
        this.refresh();
    },
};
</script>
